import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider, useAuth, getLandingRoute } from './hooks/useAuth'
import { ThemeProvider } from './hooks/useTheme'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import SellerLoginPage from './pages/SellerLoginPage'
import AdminLoginPage from './pages/AdminLoginPage'
import SellerRegisterPage from './pages/SellerRegisterPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import DashboardPage from './pages/seller/DashboardPage'
import CustomersPage from './pages/seller/CustomersPage'
import SellerSalesPage from './pages/seller/SalesPage'
import OrdersPage from './pages/seller/OrdersPage'
import TrackingPage from './pages/seller/TrackingPage'
import SellerRoutesPage from './pages/seller/RoutesPage'
import SellerProductsPage from './pages/seller/ProductsPage'
import ProfilePage from './pages/seller/ProfilePage'
import SettingsPage from './pages/SettingsPage'
import HelpPage from './pages/HelpPage'
import SellerMessagesPage from './pages/seller/MessagesPage'
import AdminDashboardPage from './pages/admin/AdminDashboardPage'
import AdminMessagesPage from './pages/admin/MessagesPage'
import SalesPage from './pages/admin/SalesPage'
import AdminOrdersPage from './pages/admin/OrdersPage'
import RoutesPage from './pages/admin/RoutesPage'
import ComplaintsPage from './pages/admin/ComplaintsPage'
import CollaboratorsPage from './pages/admin/CollaboratorsPage'
import AdminProductsPage from './pages/admin/ProductsPage'
import LogisticaPage from './pages/shared/LogisticaPage'
import RrhhPage from './pages/collaborator/RrhhPage'
import FinanzasPage from './pages/shared/FinanzasPage'
import ChooseBusinessPage from './pages/ChooseBusinessPage'
import FxDashboardPage from './pages/fx/DashboardPage'
import FxSuppliersPage from './pages/fx/SuppliersPage'
import FxProductsPage from './pages/fx/ProductsPage'
import FxPurchasesPage from './pages/fx/PurchasesPage'
import FxPurchaseOrdersPage from './pages/fx/PurchaseOrdersPage'
import FxCustomersPage from './pages/fx/CustomersPage'
import FxOrdersPage from './pages/fx/OrdersPage'
import FxSalesPage from './pages/fx/SalesPage'
import FxFinanzasPage from './pages/fx/FinanzasPage'
import FxServiceCostsPage from './pages/fx/ServiceCostsPage'
import FxLocationsPage from './pages/fx/LocationsPage'

function IndexRedirect() {
  const { user } = useAuth()
  return <Navigate to={getLandingRoute(user)} replace />
}

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/seller" element={<SellerLoginPage />} />
          <Route path="/login/admin" element={<AdminLoginPage />} />
          <Route path="/register/seller" element={<SellerRegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/choose-business" element={<ChooseBusinessPage />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<IndexRedirect />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="tracking" element={<TrackingPage />} />
            <Route path="products" element={<SellerProductsPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="help" element={<HelpPage />} />
            <Route path="messages" element={<SellerMessagesPage />} />
            <Route path="sales" element={<SellerSalesPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="routes" element={<SellerRoutesPage />} />
            <Route path="logistica" element={<LogisticaPage />} />
            <Route path="rrhh" element={<RrhhPage />} />
            <Route path="finanzas" element={<FinanzasPage />} />
            <Route path="admin" element={<AdminDashboardPage />} />
            <Route path="admin/products" element={<AdminProductsPage />} />
            <Route path="admin/production" element={<LogisticaPage />} />
            <Route path="admin/finanzas" element={<FinanzasPage />} />
            <Route path="admin/sales" element={<SalesPage />} />
            <Route path="admin/orders" element={<AdminOrdersPage />} />
            <Route path="admin/routes" element={<RoutesPage />} />
            <Route path="admin/complaints" element={<ComplaintsPage />} />
            <Route path="admin/collaborators" element={<CollaboratorsPage />} />
            <Route path="admin/messages" element={<AdminMessagesPage />} />
            <Route path="fx" element={<Navigate to="/fx/dashboard" replace />} />
            <Route path="fx/dashboard" element={<FxDashboardPage />} />
            <Route path="fx/suppliers" element={<FxSuppliersPage />} />
            <Route path="fx/products" element={<FxProductsPage />} />
            <Route path="fx/purchases" element={<FxPurchasesPage />} />
            <Route path="fx/purchase-orders" element={<FxPurchaseOrdersPage />} />
            <Route path="fx/customers" element={<FxCustomersPage />} />
            <Route path="fx/orders" element={<FxOrdersPage />} />
            <Route path="fx/sales" element={<FxSalesPage />} />
            <Route path="fx/finanzas" element={<FxFinanzasPage />} />
            <Route path="fx/service-costs" element={<FxServiceCostsPage />} />
            <Route path="fx/locations" element={<FxLocationsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  )
}

export default App
